export default (theme) => ({
  root: {
    padding: theme.spacing(3)
  },
  header: {
    fontWeight: 700
  }
});
